import "./Header.modules.scss";

import React, { Component } from "react";

// * Documentation: https://github.com/greensock/GSAP
import gsap from "gsap";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.logoRef = React.createRef();
  }

  componentDidMount() {
    gsap.to(this.logoRef.current, {
      opacity: 1,
      duration: 2,
      ease: "expo.out",
    });
  }

  render() {
    return (
      <div className="header">
        <div className="container">
          <svg
            ref={this.logoRef}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 125.4 35.4"
            style={{
              enableBackground: "new 0 0 125.4 35.4",
            }}>
            <path d="M0,0h4.2v0.5H2.4v5.3H1.8V0.5H0V0z" />
            <path d="M5,5.8V0h0.5v2.5h3.4V0h0.6v5.8H8.9V2.9H5.5v2.8H5z" />
            <path d="M10.7,5.8V0h3.8v0.5h-3.3v2.1h3V3h-3v2.3h3.4v0.5H10.7z" />
            <path d="M0,33.3l2.8-7.2h0.8l2.8,7.2H5.7L4.8,31H1.6l-0.9,2.3H0z M1.8,30.4h2.8l-1.4-3.8L1.8,30.4z" />
            <path
              d="M10.8,28.1h0.6v5.2h-0.6v-0.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.5,0.2
	c-0.2,0.1-0.4,0.1-0.6,0.1c-0.3,0-0.6,0-0.9-0.1C8,33.2,7.8,33,7.7,32.8c-0.2-0.2-0.3-0.4-0.3-0.6c-0.1-0.2-0.1-0.5-0.1-0.8v-3.4
	h0.6v3.4c0,0.4,0.1,0.7,0.3,1c0.3,0.2,0.6,0.4,1,0.3c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.3-0.6
	c0.1-0.3,0.1-0.5,0.1-0.8L10.8,28.1z"
            />
            <path
              d="M16.8,28.1h0.6v4.7c0,0.3,0,0.7-0.1,1c-0.1,0.3-0.2,0.6-0.4,0.8c-0.2,0.3-0.5,0.5-0.7,0.6
	c-0.4,0.2-0.8,0.2-1.2,0.2c-0.3,0-0.7,0-1-0.1c-0.2-0.1-0.5-0.2-0.7-0.4c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.2-0.1-0.3-0.1-0.5h0.6
	c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.4,0,0.5,0c0.4,0,0.7,0,1-0.2
	c0.2-0.1,0.4-0.3,0.6-0.5c0.1-0.2,0.2-0.5,0.2-0.8c0-0.3,0-0.6,0-0.9c-0.2,0.3-0.5,0.6-0.8,0.7c-0.3,0.2-0.6,0.3-1,0.3
	c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.3-0.1-0.7-0.1-1c0-0.4,0-0.7,0.1-1.1
	c0.1-0.3,0.2-0.6,0.4-0.9c0.2-0.2,0.4-0.4,0.7-0.6c0.3-0.1,0.7-0.2,1-0.2c0.2,0,0.3,0,0.5,0.1c0.2,0,0.4,0.1,0.5,0.2
	c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5l0,0L16.8,28.1z M16.8,30.7c0-0.3,0-0.6-0.1-0.9c-0.1-0.2-0.2-0.5-0.3-0.7
	c-0.1-0.2-0.3-0.4-0.6-0.5c-0.2-0.1-0.5-0.2-0.8-0.2c-0.2,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.2-0.3,0.4-0.4,0.6
	c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.6,0.1,0.9c0.1,0.3,0.2,0.5,0.3,0.7c0.1,0.2,0.3,0.4,0.6,0.5c0.2,0.1,0.5,0.2,0.8,0.2
	c0.3,0,0.5,0,0.7-0.2c0.2-0.1,0.4-0.3,0.6-0.5c0.1-0.2,0.3-0.4,0.3-0.7C16.8,31.3,16.8,31,16.8,30.7z"
            />
            <path
              d="M19.5,33.3h-0.6v-5.2h0.6v0.8l0,0c0.1-0.3,0.4-0.5,0.7-0.7c0.3-0.2,0.6-0.2,0.9-0.2c0.2,0,0.4,0,0.6,0.1
	c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.2,0.2,0.4c0.1-0.3,0.4-0.6,0.7-0.8c0.3-0.2,0.6-0.3,1-0.2
	c0.3,0,0.6,0,0.9,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2,0,0.5,0,0.8v3.3h-0.6v-3.6c0-0.3-0.1-0.6-0.2-0.9
	c-0.2-0.2-0.5-0.4-0.9-0.3c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.4
	c0,0.1,0,0.3,0,0.4s0,0.2,0,0.4v2.8h-0.6v-3.6c0-0.3-0.1-0.6-0.2-0.9c-0.2-0.2-0.5-0.4-0.9-0.3c-0.2,0-0.4,0-0.6,0.1
	c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.3,0,0.4s0,0.2,0,0.4L19.5,33.3z"
            />
            <path
              d="M27.6,30.8c0,0.3,0,0.5,0.1,0.8c0.1,0.2,0.2,0.5,0.3,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.5,0.2,0.8,0.2
	c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.5-0.5,0.6-0.9h0.7c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.2-0.4,0.3-0.6,0.4
	c-0.3,0.1-0.6,0.1-0.9,0.1c-0.4,0-0.7-0.1-1.1-0.2c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.3-0.3-0.5-0.4-0.9C27,31.4,27,31,27,30.7
	c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.2,0.5-0.5,0.7-0.6c0.3-0.1,0.6-0.2,1-0.2c0.6,0,1.3,0.2,1.7,0.7
	c0.5,0.6,0.7,1.4,0.6,2.1L27.6,30.8z M31,30.3c0-0.2,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.6c-0.5-0.5-1.3-0.7-1.9-0.4
	c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.1,0.5-0.2,0.7L31,30.3z"
            />
            <path
              d="M33.4,33.3h-0.6v-5.2h0.6v0.7c0.2-0.2,0.5-0.5,0.8-0.6s0.6-0.2,0.9-0.2c0.3,0,0.6,0.1,0.9,0.2s0.5,0.3,0.7,0.6
	c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2,0,0.4,0,0.6v3.4h-0.6v-3.4c0-0.4-0.1-0.8-0.3-1c-0.3-0.2-0.6-0.4-1-0.4c-0.2,0-0.3,0-0.5,0.1
	c-0.2,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0,0.5L33.4,33.3z"
            />
            <path
              d="M40.2,33.3l-0.3,0.1c-0.1,0-0.3,0-0.4,0c-0.2,0-0.5-0.1-0.7-0.2c-0.2-0.2-0.3-0.5-0.2-0.8v-3.7h-0.7v-0.5h0.7
	v-1.4h0.6v1.4h1v0.5h-1v3.6c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0
	l0.2,0L40.2,33.3z"
            />
            <path
              d="M41.5,30.8c0,0.3,0,0.5,0.1,0.8c0.1,0.2,0.2,0.5,0.3,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.5,0.2,0.8,0.2
	c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.5-0.5,0.6-0.9h0.7c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.2-0.4,0.3-0.6,0.4
	c-0.3,0.1-0.6,0.1-0.9,0.1c-0.4,0-0.7-0.1-1.1-0.2c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.3-0.3-0.5-0.4-0.9c-0.1-0.4-0.1-0.7-0.1-1.1
	s0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.2,0.5-0.5,0.7-0.6c0.3-0.1,0.7-0.2,1-0.2c0.7,0,1.3,0.2,1.7,0.7
	c0.5,0.6,0.7,1.4,0.6,2.1L41.5,30.8z M44.9,30.3c0-0.2,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.6c-0.5-0.5-1.3-0.7-1.9-0.4
	c-0.2,0.1-0.4,0.2-0.5,0.4c-0.2,0.2-0.3,0.4-0.3,0.6c-0.1,0.2-0.1,0.5-0.2,0.7L44.9,30.3z"
            />
            <path
              d="M50.7,26.1h0.6v7.2h-0.6v-0.9l0,0c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.5,0.3s-0.3,0.2-0.5,0.2
	c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0-0.7-0.1-1.1-0.2c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.3-0.3-0.5-0.4-0.9c-0.1-0.4-0.1-0.7-0.1-1.1
	c0-0.3,0-0.7,0.1-1c0.1-0.3,0.2-0.6,0.4-0.9c0.2-0.2,0.4-0.5,0.7-0.6c0.3-0.1,0.7-0.2,1-0.2c0.4,0,0.7,0.1,1.1,0.2s0.6,0.4,0.8,0.7
	L50.7,26.1z M50.7,30.6c0-0.3,0-0.6-0.1-0.8c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.1-0.5-0.2-0.7-0.2
	c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.6,0.5c-0.2,0.2-0.2,0.5-0.3,0.8c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.6,0.1,0.9
	c0.1,0.2,0.2,0.5,0.4,0.6c0.2,0.2,0.3,0.3,0.6,0.4c0.2,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5,0,0.8-0.2c0.2-0.1,0.4-0.3,0.5-0.5
	c0.2-0.2,0.3-0.5,0.3-0.7C50.7,31.2,50.7,31,50.7,30.6z"
            />
            <path
              d="M56.4,30v3.3h-0.7v-7.2h2.8c0.6,0,1.3,0.1,1.8,0.5c0.5,0.3,0.7,0.9,0.7,1.5c0,0.4-0.1,0.7-0.3,1
	c-0.2,0.3-0.5,0.5-0.9,0.7c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5s0.1,0.4,0.1,0.6c0,0.2,0,0.4,0,0.6s0,0.5,0,0.7
	c0,0.2,0,0.3,0.1,0.4c0,0.1,0,0.2,0.1,0.3c0,0,0.1,0.1,0.1,0.1v0.1h-0.8c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.2-0.1-0.5-0.1-0.7
	c0-0.2,0-0.5,0-0.7c0-0.2,0-0.4-0.1-0.5c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.2-0.2-0.3-0.3C59.3,30,59.1,30,59,30c-0.2,0-0.3,0-0.5,0
	C58.5,30,56.4,30,56.4,30z M58.5,29.4c0.2,0,0.5,0,0.7-0.1c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.1-0.6
	c0-0.2,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.4-0.1-0.7-0.1h-2.2v2.8L58.5,29.4z"
            />
            <path
              d="M62.7,30.8c0,0.3,0,0.5,0.1,0.8c0.1,0.2,0.2,0.5,0.3,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.5,0.2,0.8,0.2
	c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.5-0.5,0.6-0.9h0.7c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.2-0.4,0.3-0.6,0.4
	c-0.3,0.1-0.6,0.1-0.9,0.1c-0.4,0-0.7-0.1-1.1-0.2c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.3-0.3-0.5-0.4-0.9C62,31.4,62,31,62,30.7
	c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.2,0.5-0.5,0.7-0.6c0.3-0.1,0.6-0.2,1-0.2c0.7,0,1.3,0.2,1.7,0.7
	c0.4,0.6,0.7,1.4,0.6,2.1L62.7,30.8z M66,30.3c0-0.2,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.6c-0.5-0.5-1.3-0.7-1.9-0.4
	c-0.2,0.1-0.4,0.2-0.5,0.4c-0.2,0.2-0.3,0.4-0.3,0.6c-0.1,0.2-0.1,0.5-0.2,0.7L66,30.3z"
            />
            <path
              d="M70.2,30.2l0.4-0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.5-0.3-0.8
	c-0.3-0.2-0.6-0.3-1-0.3c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.2-0.2,0.4-0.2,0.6h-0.6
	c0-0.3,0.1-0.5,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1c0.2,0,0.5,0,0.7,0.1
	c0.2,0,0.4,0.1,0.6,0.3c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.5,0.1,0.8v2.8c0,0.2,0,0.4,0.1,0.5s0.2,0,0.5,0v0.5l-0.2,0.1
	c-0.1,0-0.2,0-0.3,0h-0.3c-0.1,0-0.2,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.2,0-0.3
	c-0.2,0.3-0.5,0.5-0.9,0.6c-0.3,0.2-0.7,0.2-1.1,0.2c-0.2,0-0.4,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.5
	c-0.1-0.2-0.2-0.4-0.1-0.7c0-0.9,0.6-1.4,1.8-1.6L70.2,30.2z M71.2,30.5c-0.2,0.1-0.5,0.2-0.8,0.2c-0.3,0-0.5,0.1-0.8,0.1
	c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.4,0.2
	c0.1,0,0.3,0,0.4,0c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7L71.2,30.5z"
            />
            <path d="M73.5,33.3v-7.2h0.6v7.2H73.5z" />
            <path d="M75.7,27v-0.9h0.7V27H75.7z M75.7,33.3v-5.2h0.6v5.2L75.7,33.3z" />
            <path
              d="M79.7,33.3l-0.3,0.1c-0.1,0-0.3,0-0.4,0c-0.2,0-0.5-0.1-0.7-0.2c-0.2-0.2-0.3-0.5-0.2-0.8v-3.7h-0.7v-0.5h0.7
	v-1.4h0.6v1.4h1v0.5h-1v3.6c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0
	l0.2,0L79.7,33.3z"
            />
            <path
              d="M80.6,34.7h0.2c0.1,0,0.2,0,0.2,0c0.2,0,0.3,0,0.4-0.2s0.2-0.2,0.3-0.4c0.1-0.2,0.1-0.3,0.2-0.5
	c0-0.1,0.1-0.3,0.2-0.4l-2-5.2h0.7l1.7,4.4l1.7-4.5h0.7l-1.9,5.1c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.2-0.2,0.5-0.3,0.7
	c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.3,0.2-0.5,0.1c-0.1,0-0.2,0-0.3,0l-0.3,0L80.6,34.7z"
            />
            <path
              d="M2.8,16.2c0,0.4,0.2,0.8,0.4,1.2c0.5,0.5,1.3,0.8,2,0.7c0.5,0,1,0,1.4-0.2c0.6-0.2,1-0.7,1-1.3
	c0-0.4-0.2-0.7-0.5-0.9c-0.5-0.3-1-0.4-1.6-0.5l-1.2-0.3c-0.9-0.1-1.7-0.4-2.5-0.9c-0.8-0.6-1.2-1.5-1.2-2.5c0-1,0.4-1.9,1.1-2.5
	C2.8,8.3,4,7.9,5.2,8c1.1,0,2.2,0.3,3.1,1c0.9,0.7,1.4,1.7,1.4,2.8H7.4c0-0.6-0.4-1.2-0.9-1.5C6,10.1,5.5,9.9,5,9.9
	c-0.5,0-1.1,0.1-1.5,0.4c-0.3,0.2-0.6,0.6-0.6,1c0,0.4,0.2,0.8,0.6,0.9c0.5,0.2,1,0.4,1.5,0.5l2,0.5c0.7,0.1,1.4,0.4,2,0.8
	c0.7,0.6,1.1,1.4,1,2.4c0,1-0.4,1.9-1.1,2.6c-1,0.7-2.2,1.1-3.4,1c-1.3,0.1-2.5-0.3-3.6-1c-0.9-0.7-1.4-1.7-1.3-2.8L2.8,16.2z"
            />
            <path
              d="M20.6,18.8c-1,1-2.4,1.4-3.8,1.4c-1.4,0.1-2.8-0.4-3.8-1.4c-1.2-1.3-1.9-3-1.8-4.8c-0.1-1.8,0.5-3.5,1.8-4.8
	c1-0.9,2.4-1.4,3.8-1.3c1.4-0.1,2.8,0.4,3.8,1.3c1.2,1.3,1.9,3,1.7,4.8C22.5,15.8,21.9,17.5,20.6,18.8z M19.1,17
	c0.6-0.9,0.9-1.9,0.9-3c0.1-1.1-0.2-2.1-0.8-3c-0.6-0.7-1.4-1.1-2.3-1c-0.9-0.1-1.7,0.3-2.3,1c-0.6,0.9-0.9,1.9-0.9,3
	c-0.1,1.1,0.2,2.1,0.9,3c0.6,0.7,1.4,1.1,2.3,1.1C17.7,18.1,18.6,17.7,19.1,17z"
            />
            <path d="M24.2,8.3h2.4v9.4h5.8v2.1h-8.1C24.2,19.8,24.2,8.3,24.2,8.3z" />
            <path d="M37.3,8.3H40l4.1,11.5h-2.6l-0.8-2.4h-4.2l-0.8,2.4h-2.5L37.3,8.3z M37.1,15.4h3l-1.5-4.5L37.1,15.4z" />
            <path
              d="M52.9,8.6C53.3,8.7,53.7,9,54,9.4c0.2,0.3,0.4,0.6,0.6,1c0.2,0.4,0.2,0.8,0.2,1.2c0,0.6-0.2,1.1-0.4,1.6
	c-0.3,0.5-0.8,0.9-1.4,1.1c0.5,0.2,0.9,0.5,1.1,0.9c0.3,0.6,0.4,1.2,0.3,1.8v0.8c0,0.4,0,0.7,0.1,1.1c0,0.3,0.2,0.5,0.4,0.7v0.3
	h-2.6c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.3-0.1-0.7-0.1-1v-1.1c0.1-0.5-0.1-1-0.4-1.5c-0.4-0.3-0.9-0.4-1.4-0.4h-2.4v4.5h-2.3V8.3h5.5
	C51.7,8.2,52.3,8.3,52.9,8.6z M47.9,10.3v3.1h2.6c0.4,0,0.8,0,1.2-0.2c0.5-0.2,0.7-0.8,0.7-1.3c0.1-0.6-0.2-1.1-0.7-1.4
	c-0.3-0.1-0.7-0.2-1.1-0.2H47.9z"
            />
            <path
              d="M63.3,16.2c0,0.4,0.2,0.8,0.4,1.2c0.6,0.5,1.3,0.8,2.1,0.7c0.5,0,0.9,0,1.4-0.2c0.6-0.1,1-0.7,1-1.3
	c0-0.4-0.2-0.7-0.5-0.9c-0.5-0.3-1-0.4-1.6-0.5l-1.2-0.3c-0.9-0.1-1.7-0.4-2.5-0.9c-0.8-0.6-1.2-1.5-1.2-2.5c0-1,0.4-1.9,1.1-2.5
	c1-0.7,2.1-1.1,3.4-1c1.1,0,2.2,0.3,3.1,1c0.9,0.7,1.4,1.7,1.4,2.8h-2.3c0-0.6-0.4-1.2-0.9-1.5C66.5,10.1,66,10,65.5,10
	c-0.5-0.1-1,0-1.5,0.3c-0.3,0.2-0.6,0.6-0.6,1c0,0.4,0.2,0.8,0.6,0.9c0.5,0.2,1,0.4,1.5,0.5l2,0.5c0.7,0.1,1.4,0.4,2,0.8
	c0.7,0.6,1.1,1.4,1,2.4c0,1-0.4,2-1.2,2.6c-1,0.7-2.2,1.1-3.4,1c-1.3,0.1-2.5-0.3-3.6-1c-0.8-0.7-1.3-1.7-1.3-2.8
	C61,16.2,63.3,16.2,63.3,16.2z"
            />
            <path d="M78.8,8.3h2.7l-3.9,7.2v4.3h-2.4v-4.3l-4-7.2h2.8l2.4,5L78.8,8.3z" />
            <path
              d="M84.6,16.2c0,0.4,0.2,0.8,0.4,1.2c0.5,0.5,1.3,0.8,2,0.7c0.5,0,1,0,1.4-0.2c0.6-0.1,1-0.7,1-1.3
	c0-0.4-0.2-0.7-0.5-0.9c-0.5-0.3-1-0.4-1.6-0.5l-1.2-0.3c-0.9-0.2-1.7-0.5-2.4-0.9c-0.8-0.6-1.2-1.5-1.2-2.5c0-1,0.4-1.9,1.1-2.5
	c0.9-0.7,2.2-1.1,3.3-1c1.1,0,2.2,0.3,3.1,1c0.9,0.7,1.4,1.7,1.4,2.8h-2.3c0-0.6-0.4-1.2-0.9-1.5c-0.4-0.2-0.9-0.3-1.4-0.3
	c-0.5,0-1.1,0.1-1.5,0.4c-0.3,0.2-0.6,0.6-0.6,1c0,0.4,0.2,0.8,0.6,0.9c0.5,0.2,1,0.4,1.5,0.5l2,0.5c0.7,0.1,1.4,0.4,2,0.8
	c0.7,0.6,1.1,1.4,1,2.3c0,1-0.4,1.9-1.2,2.5c-1,0.7-2.2,1.1-3.4,1c-1.3,0.1-2.5-0.3-3.6-1c-0.9-0.7-1.3-1.7-1.3-2.8L84.6,16.2z"
            />
            <path d="M101.9,8.3v2h-3.4v9.5h-2.4v-9.4h-3.5v-2L101.9,8.3z" />
            <path d="M111.8,10.3h-6.1v2.4h5.6v2h-5.6v3h6.4v2.1h-8.7V8.3h8.4L111.8,10.3z" />
            <path
              d="M121.6,8.3h3.5v11.5h-2.2V11c0-0.4,0-0.7,0-0.9l-2.2,9.7h-2.3l-2.2-9.7V11c0,0.4,0,0.7,0,1v7.8H114V8.3h3.5
	l2.1,9L121.6,8.3z"
            />
            <rect x="0.4" y="22.2" width="125" height="1" />
          </svg>
        </div>
      </div>
    );
  }
}
